<template>
  <div class="header-container">
    <el-header class="header-content">
      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-btn" @click="toggleMobileMenu" v-if="isMobile">
        <i class="el-icon-menu"></i>
      </div>
      <!-- 左侧：用户信息 -->
      <div class="header-left">
        <div class="user-info">
          <div class="user-details">
            <div class="user-name">{{proxy?proxy.real_name:'管理员'}}</div>
            <div class="user-role">{{proxy?proxy.role_name:'系统管理员'}}</div>
          </div>
          <div>
            <div class="current-date">{{ nowDate }}</div>
            <div class="current-week">{{ nowWeek }}</div>
          </div>
        </div>
      </div>


      <!-- 右侧：用户操作 -->
      <div class="header-right">
        <!-- 校园选择（可选） -->
        <!-- <el-dropdown class="campus-dropdown">
          <span class="campus-trigger">
            <i class="el-icon-location-outline"></i>
            <span>{{ campusNow }}</span>
            <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in campusList" :key="item.id">
              {{ item.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->

        <!-- 用户操作 -->
        <el-dropdown class="user-dropdown" trigger="click">
          <div class="user-account">
            <div class="account-content">
              <div class="account-info">
                <div class="account-name">{{ userName }}</div>
                <div class="account-status">在线</div>
              </div>
              <i class="el-icon-arrow-down"></i>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown" class="user-menu">
            <el-dropdown-item @click.native="userInfo" class="menu-item">
              <i class="el-icon-user-solid"></i>
              <span>用户中心</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="changePassword" class="menu-item">
              <i class="el-icon-lock"></i>
              <span>修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout" class="menu-item logout-item">
              <i class="el-icon-switch-button"></i>
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>

    <!-- 修改密码弹框 -->
    <el-dialog
            title="修改密码"
            :visible.sync="dialogPassword"
            width="500px"
            :append-to-body="true"
            custom-class="password-dialog"
            center>
      <div class="dialog-icon">
        <i class="el-icon-lock"></i>
      </div>
      <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="100px">
        <el-form-item label="账号" prop="user_name">
          <el-input
                  v-model="pwdForm.user_name"
                  readonly
                  autocomplete="off"
                  placeholder="请输入账号"
                  prefix-icon="el-icon-user">
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input
                  v-model="pwdForm.password"
                  type="password"
                  autocomplete="off"
                  placeholder="请输入新密码"
                  prefix-icon="el-icon-key"
                  show-password>
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repassword">
          <el-input
                  v-model="pwdForm.repassword"
                  type="password"
                  autocomplete="off"
                  placeholder="请再次输入新密码"
                  prefix-icon="el-icon-key"
                  show-password>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pwdReset_dialogForm('pwdForm')" class="cancel-btn">取 消</el-button>
        <el-button type="primary" @click="pwdSubmitForm('pwdForm')" class="submit-btn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { hexMD5 } from '../../utils/md5' //引入

  export default {
    name:"HeaderView",
    data(){
      return {
        shop:{},
        nowWeek: "",
        nowDate: "",
        userName: '',
        isMobile: false,
        campusList: [],
        campusNow: "",
        model:'',
        ip: "",
        dialogPassword: false,
        pwdForm: {
          user_name: sessionStorage.getItem('userName'),
          password: '',
          repassword: '',
        },
        pwdRules: {
          password: [
            { required: true, message: "请输入新密码", trigger: "blur" },
            { min: 6, message: "密码长度不能少于6位", trigger: "blur" }
          ],
          repassword: [
            { required: true, message: "请再次输入新密码", trigger: "blur" },
            {
              validator: (rule, value, callback) => {
                if (value !== this.pwdForm.password) {
                  callback(new Error('两次输入的密码不一致'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
        },
      }
    },
    created() {
      this.setNowTimes()
      this.campus()
      this.userName = window.sessionStorage.getItem('userName');
      this.proxy = JSON.parse(sessionStorage.getItem("proxy"));
      this.checkMobile();
      window.addEventListener('resize', this.checkMobile);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkMobile);
    },
    methods:{
      checkMobile() {
        this.isMobile = window.innerWidth < 992;
      },

      toggleMobileMenu() {
        this.$emit('toggle-mobile-menu');
      },

      // ... 其他原有方法保持不变
      campus() {
        if (localStorage.getItem("campus") != null) {
          this.campusNow = localStorage.getItem("campus");
          if (this.campusNow == 1) {
            this.campusNow = "中国";
          }
          if (this.campusNow == 2) {
            this.campusNow = "泰国";
          }
          if (this.campusNow == 3) {
            this.campusNow = "韩国";
          }
        }
        if (this.campusList.length == 0) {
          // this.$axios.get("campus.json").then((res) => {
          //     if (res.status == 200) {
          //     console.log(res.data.campus);
          //     this.campusList = res.data.campus;
          //     } else {
          //     this.$message.error("地区国家获取失败，请联系管理员~");
          //     }
          // });
        }
      },
      getCampusList(command) {
        // this.campusNow = command;
        localStorage.setItem("campus", command);
        this.campus();
        this.$message.success("已切换到" + this.campusNow + "地区");
      },
      //个人信息
      userInfo() {
        this.$router.push("/userInfo");
      },
      //用户退出
      logout() {
        this.$confirm('确定要退出登录吗？', '退出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
          customClass: 'logout-confirm'
        }).then(() => {
          this.$message.success('退出成功');
          window.sessionStorage.clear();
          this.$router.push("/login");
        }).catch(() => {
          this.$message.info('已取消退出');
        });
      },

      setNowTimes() {
        //获取当前时间
        let myDate = new Date();
        let wk = myDate.getDay();
        let yy = String(myDate.getFullYear() + "年");
        let mm = myDate.getMonth() + 1 + "月";
        let dd = String(
                myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate() + "日"
        );
        let weeks = [
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六",
        ];
        let week = weeks[wk];
        this.nowDate = yy + "-" + mm + "-" + dd;
        this.nowWeek = week;
      },
      changePassword() {
        this.dialogPassword = true
        // 重置表单数据
        this.$nextTick(() => {
          this.pwdForm.password = '';
          this.pwdForm.repassword = '';
        });
      },
      pwdReset_dialogForm(formName) {
        this.dialogPassword = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      pwdSubmitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const param = {
              id: sessionStorage.getItem('user_id'),
              password: hexMD5(this.pwdForm.password),
              repassword: hexMD5(this.pwdForm.repassword),
              access_token: sessionStorage.getItem('token'),
            }
            this.$axios.shopUserChangePsw(param).then(res => {
              if(res.code==200){
                this.$message.success(res.msg)
                this.dialogPassword = false
              }
            }).catch(function (error) {
              console.log(error);
            })
          }
        })
      },
    }
  }
</script>

<style scoped>
  .header-container {
    width: 100%;
    height: 100%;
  }

  .header-content {
    height: 100% !important;
    padding: 0 24px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: white !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }

  .mobile-menu-btn {
    display: none;
    cursor: pointer;
    color: #606266;
    font-size: 20px;
    padding: 8px;
    border-radius: 4px;
    margin-right: 15px;
    transition: all 0.3s;
  }

  .mobile-menu-btn:hover {
    background: #f5f7fa;
    color: #409eff;
  }

  .header-left {
    display: flex;
    align-items: center;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 6px 12px;
    border-radius: 6px;
    transition: all 0.3s;
  }

  .user-info:hover {
    background: #f5f7fa;
  }

  .user-details {
    display: flex;
    flex-direction: column;
    line-height: 1.4;
  }

  .user-name {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }

  .user-role {
    font-size: 12px;
    color: #909399;
  }

  .header-center {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .date-info {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #606266;
    padding: 8px 16px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e7ed 100%);
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  }

  .date-info i {
    font-size: 20px;
    color: #409eff;
  }

  .date-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .current-date {
    font-size: 15px;
    font-weight: 500;
  }

  .current-week {
    font-size: 13px;
    opacity: 0.8;
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  /* 校园选择 */
  .campus-dropdown {
    cursor: pointer;
  }

  .campus-trigger {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border-radius: 6px;
    color: #606266;
    transition: all 0.3s;
  }

  .campus-trigger:hover {
    background: #f5f7fa;
    color: #409eff;
  }

  /* 用户下拉菜单 */
  .user-dropdown {
    cursor: pointer;
  }

  .user-account {
    padding: 8px 12px;
    border-radius: 6px;
    transition: all 0.3s;
  }

  .user-account:hover {
    background: #f5f7fa;
  }

  .account-content {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #333;
  }

  .account-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.4;
  }

  .account-name {
    font-size: 14px;
    font-weight: 500;
  }

  .account-status {
    font-size: 11px;
    color: #67c23a;
  }

  /* 响应式调整 */
  @media screen and (max-width: 1200px) {
    .header-content {
      padding: 0 20px !important;
    }

    .date-info {
      padding: 8px 12px;
    }
  }

  @media screen and (max-width: 992px) {
    .mobile-menu-btn {
      display: block;
    }

    .header-center {
      display: none;
    }

    .user-role {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    .header-content {
      padding: 0 16px !important;
    }

    .user-details {
      display: none;
    }

    .header-right {
      gap: 12px;
    }

    .account-info {
      display: none;
    }

    .account-content .el-icon-arrow-down {
      display: none;
    }
  }

  @media screen and (max-width: 576px) {
    .header-content {
      padding: 0 12px !important;
    }

    .user-info {
      padding: 4px 6px;
    }
  }
</style>
